var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","checked":""},on:{"change":_vm.toggleSwitch}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }